import { ApiClient } from "./api";

class ConfigApi extends ApiClient {
    constructor() {
        super();
    }

    getPageBuilder(pageName, dealerId, userId) {
        const path = "/configuration/builder";
        const params = {
            dealerId: dealerId,
            page: pageName,
            userId: userId,
        };

        return this.get(path, params);
    }

    getDefaults(pageName, dealerId, userId) {
        const path = "/configuration";
        const params = {
            dealerId: dealerId,
            page: pageName,
            userId: userId,
        };

        return this.get(path, params);
    }

    save(pageName, dealerId, userId, data) {
        const path = "/configuration";
        const params = {
            dealerId: dealerId,
            page: pageName,
            userId: userId,
        };

        return this.post(path, data, {
            params,
            paramsSerializer: (params) => {
                return Object.entries(params)
                    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                    .join("&");
            },
        });
    }

    getAuditData(pageName, dealerId, page, size) {
        const path = "/configuration/qrcode/audit/log";
        const params = {
            dealerId: dealerId,
            page: page,
            size: size,
            pageName: pageName,
        };

        return this.get(path, params);
    }

    uploadFiles(pageName, dealerId, userId, formData) {
        const path = "/configuration";
        const params = {
            dealerId: dealerId,
            page: pageName,
            userId: userId,
        };

        return this.httpClient.post(this.basePath + path, formData, {
            params,
            headers: {
                "Content-Type": "multipart/form-data",
            },
            paramsSerializer: (params) => {
                return Object.entries(params)
                    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                    .join("&");
            },
        });
    }
}

export default new ConfigApi();
